import type { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro';
import { AvailableColumnTypes } from './enum';
import { renderMap } from './renderMap';
import { CustomGridColDef } from './types';

export const columnRenderer = <T extends GridValidRowModel>(columns: CustomGridColDef<T>[]): GridColDef<T>[] =>
  columns.map((column) => {
    if (
      column.type === AvailableColumnTypes.custom ||
      column.type === AvailableColumnTypes.actions ||
      column.type === AvailableColumnTypes.customFormatter ||
      column.type === AvailableColumnTypes.treeData ||
      column.type === AvailableColumnTypes.check ||
      ('renderCell' in column && column.renderCell)
    ) {
      return column as GridColDef<T>;
    }

    return {
      ...column,
      ...renderMap[column.type || AvailableColumnTypes.string],
    } as GridColDef<T>;
  });
